export type StickyMode = "fixed" | "reveal";

export function resolveBounds({
  stickyTopPx,
  viewportHeight,
  sidebarHeight,
  mode,
}: {
  stickyTopPx: number;
  viewportHeight: number;
  sidebarHeight: number;
  mode: StickyMode;
}): { upperBound: number; lowerBound: number } {
  const upperBound = stickyTopPx;

  if (mode === "fixed") {
    return { upperBound, lowerBound: upperBound };
  }

  const availableHeight = viewportHeight - stickyTopPx;
  if (sidebarHeight <= availableHeight) {
    return { upperBound, lowerBound: upperBound };
  }

  return { upperBound, lowerBound: viewportHeight - sidebarHeight };
}

export function resolveRevealTop({
  prevTop,
  scrollDeltaY,
  lowerBound,
  upperBound,
}: {
  prevTop: number;
  scrollDeltaY: number;
  lowerBound: number;
  upperBound: number;
}): number {
  const next = prevTop - scrollDeltaY;
  return Math.max(lowerBound, Math.min(upperBound, next));
}
